import Model, { hasMany } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class BulkCustomPropertyAttributeModel extends Model {
  @hasMany('custom-property-attribute', { inverse: null, async: false })
  customPropertyAttributes!: ModelRegistry['custom-property-attribute'][];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'bulk-custom-property-attribute': BulkCustomPropertyAttributeModel;
  }
}
